import type { Extensions } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";

const richTextExtensions: Extensions = [
  StarterKit.configure({
    codeBlock: false,
    code: false,
    heading: false,
  }) as Extensions[number],
];

export { richTextExtensions };
